import { TTabsSize, TTabRowVariant, Maybe } from '@/types';

export const tabsContentStyles = (params?: { isTabsFixed?: boolean }) => ({
	...(params?.isTabsFixed && { height: '299px' }),
	width: '100%',
});

export const getTabsListWrapStyles = (params?: { tabRowVariant?: TTabRowVariant; isSmallScreen?: boolean }) => ({
	...(params?.tabRowVariant === 'Filled' && {
		backgroundColor: 'neutrals.neutral',
		paddingLeft: params?.isSmallScreen ? 0 : '5%',
		paddingRight: params?.isSmallScreen ? 0 : '5%',
		borderColor: 'neutrals.disabled',

		'& .MuiTabs-indicator': {
			display: 'none',
		},
	}),
});

export const getTabsWrapperStyles = (params?: {
	tabRowVariant?: TTabRowVariant;
	isTabsFixed?: boolean;
	headerPositioning?: { minHeight: { xs: string; md: string } };
	withDisappearingHeader?: boolean;
	desktopHeaderDisappearingTopStyle?: string;
	mobileHeaderDisappearingTopStyle?: string;
	defaultValueIndex?: Maybe<string>;
}) => {
	const xsHeaderMinHeight = params?.headerPositioning?.minHeight.xs ?? '0rem';
	const mdHeaderMinHeight = params?.headerPositioning?.minHeight.md ?? '0rem';

	const xsDisappearingHeader = params?.mobileHeaderDisappearingTopStyle !== '0px' ? '0rem' : xsHeaderMinHeight;
	const mdDisappearingHeader = params?.desktopHeaderDisappearingTopStyle !== '0px' ? '0rem' : mdHeaderMinHeight;

	return {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'right',
		position: params?.isTabsFixed ? 'fixed' : 'static',
		background: 'F7FFFF',
		top: params?.isTabsFixed
			? {
					xs: !params.withDisappearingHeader ? xsHeaderMinHeight : xsDisappearingHeader,
					md: !params.withDisappearingHeader ? mdHeaderMinHeight : mdDisappearingHeader,
			  }
			: 'auto',
		left: 0,
		transition: 'top 0.5s ease-in-out',
		width: '95%',
		zIndex: 12,
		marginTop: '7.5rem', // 120px -> 7.5rem
		borderColor: 'divider',
		marginBottom: '3.75rem', // 60px -> 3.75rem
		...(params?.tabRowVariant === 'Filled' && {
			backgroundColor: 'neutrals.neutral',
		}),
	};
};

export const tabsStyles = {
	width: '9.438rem',
	borderRadius: '20px 0 0 20px', // 8px -> 0.5rem
	background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.78) 69.54%);',
	backdropFilter: 'blur(0.625rem)', // 10px -> 0.625rem
	marginBottom: '-0.0625rem', // -1px -> -0.0625rem
	'& .MuiTabs-flexContainer': {
		alignItems: 'flex-end',
	},
	'& .MuiTabs-indicator': {
		backgroundColor: 'transparent',
	},
};

export const getTabStyles = (params?: {
	tabsSize?: TTabsSize;
	tabRowVariant?: TTabRowVariant;
	isSmallScreen?: boolean;
}) => ({
	textTransform: 'none',
	color: '#0B2341',
	fontFamily: 'Messina Sans',
	'&.Mui-selected': {
		color: '#0B2341',
		fontWeight: 900,
	},
	alignItems: 'flex-end',
	...((params?.tabsSize === 'Medium' || params?.tabsSize === 'Small' || params?.isSmallScreen) && {
		padding: '0.75rem 1rem', // 12px 16px -> 0.75rem 1rem
		minHeight: '0.625rem', // 10px -> 0.625rem
		height: '0.938rem', // 15px -> 0.938rem
		fontSize: '0.625rem', // 10px -> 0.625rem
		fontWeight: 400,
		lineHeight: '1.625rem', // 26px -> 1.625rem
	}),
	...(params?.tabsSize === 'Large' &&
		!params?.isSmallScreen && {
			padding: '1.5rem 1rem', // 24px 16px -> 1.5rem 1rem
			fontSize: '2rem', // 32px -> 2rem
			lineHeight: '2.125rem', // 34px -> 2.125rem
		}),
	...(params?.tabRowVariant === 'Filled' && {
		backgroundColor: 'neutrals.neutral',
		color: 'text.primary',
		borderBottom: '0.0625rem', // 1px -> 0.0625rem
		borderColor: 'neutrals.disabled',
		'&.Mui-selected': {
			color: 'text.interactive',
			backgroundColor: 'neutrals.white',
			border: '0.0625rem', // 1px -> 0.0625rem
			borderBottom: 'none',
			borderColor: 'neutrals.disabled',
			borderRadius: '1.5rem 1.5rem 0 0', // 24px 24px 0 0 -> 1.5rem 1.5rem 0 0
			marginBottom: '-0.0625rem', // -1px -> -0.0625rem

			'&:first-child': {
				...(params?.isSmallScreen && { borderRadius: '0 1.5rem 0 0', borderLeft: 0 }),
			},
			'&:last-child': {
				...(params?.isSmallScreen && { borderRadius: '1.5rem 0rem 0 0', borderRight: 0 }),
			},
		},
	}),
});
